import {
  $ABTest,
  $I18nText,
  $Locale,
  $RenderConfig,
  $RootTraffic,
  $UserAgent,
  $WebUser,
} from '@lemon8/web-app-shared/atom';
import { atom } from 'jotai';
import { $LegalPageLevelTraffic, $LegalRegion, $Location } from 'shared/atoms/common';
import { $EmailData } from 'shared/atoms/email';

export const $SharedAtom = atom('shared atom');

export const Atoms = {
  $Locale,
  $ABTest,
  $RenderConfig,
  $WebUser,
  $UserAgent,
  $I18nText,
  $RootTraffic,
  $SharedAtom,
  $LegalPageLevelTraffic,
  $LegalRegion,
  $Location,
  $EmailData,
};

export const AtomFamilies = {};

export * from './common';
export * from './email';
